import React from "react";
import classes from "./style.module.css";
// import MockImg from "../../../../../assets/images/joftPooch/FindDifference.jpg";
import DifferenceFinder from "./DifferenceFinder";
import { baseURL } from "../../../../../assets/constants/baseUrl";

export default function DifferenceImages({
  firstImg,
  secondImg,
  setMarker,
  pointsLength,
  rightAnswer,
}) {
  return (
    <div className={classes.imageContainer}>
      <img
        src={`${baseURL}file/get/${firstImg}`}
        alt="main-diff-img"
        crossOrigin="anonymous"
      />
      <DifferenceFinder
        imgSrc={`${baseURL}file/get/${secondImg}`}
        onSetMarker={(markers) => setMarker(markers)}
        pointsLength={pointsLength}
        rightAnswer={rightAnswer}
      />
    </div>
  );
}
